import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from './../../services/comman-uses.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss']
})
export class FinanceComponent implements OnInit {

  isSuperAdmin: boolean = false;
  constructor(
    private commanUsesService: CommanUsesService,
    private authStatusService: AuthStatusService,
    private router: Router,
  ) { }

  async ngOnInit() {
    try {
      
    } catch (error) {
      this.commanUsesService.showSnackBar(`ERROR_${error?.message || 'UNKNOWN_ERROR'}`);
    }
  }

}
